import React, { useState, useEffect, useRef } from "react";
import GenericFormHeaderComponent from "../genericComponents/forms/GenericFormHeaderComponent";
import GenericInput from "../genericComponents/input/GenericInputComponent";
import GenericFormFooterComponent from "../genericComponents/forms/GenericFormFooterComponent";
import { useDispatch, useSelector } from "react-redux";
import GenericCustomButton from "../genericComponents/GenericCustomButton";
import LanguageTranslator from "../locals/LanguageTranslator";
import Icons from "../assets/icons";
import { formatFileSize } from "../helper/helperTableFunctions";
import useCustomToast from "../hooks/useCustomToast";
import { dispatchHandler } from "../helper/apiHelperFunctions";
import { getPermissionKey } from "../helper/permissions";
const DocumentsQtyForPrint = (props = {}) => {

    const [selectedData, setSelectedData] = useState(props.selectedData || {});
    const [checkItems, setCheckItems] = useState(props.checkItems || [])

    const [step, setStep] = useState(props.type == "upload" ? 1 : 2)

    const getInitialFormData = () => {
        return checkItems?.map(item => (
            {
                "qty": 1
            }
        ))
    }

    const dispatch = useDispatch();

    const downloadDocumentsData = useSelector(state => state?.generalStore?.downloadDocumentsData);
    const getTableComponentFifthListData = useSelector(state => state?.generalStore?.getTableComponentFifthListData);

    const [formData, setFormData] = useState(getInitialFormData())


    const customToast = useCustomToast();

    const uploadFileRef = useRef();

    const [currentFile, setCurrentFile] = useState(null);

    const [loading, setLoading] = useState({});

    let type = selectedData?.item?.key || {};

    let headingMapping = {
        "ITEM_BARCODE_SINGLE": "Download Item Barcode",
        "ITEM_QR_CODE_SINGLE" : "Download QR Code",
        "MRP_LABEL_PDF": "Download MRP Label",
        "PRODUCT_LABEL_HS_SHIPMENT": "Download Product Label"
    }

    let subHeadingMapping = {
        "ITEM_BARCODE_SINGLE": "You can download the item barcode with the filled quantity",
        "ITEM_QR_CODE_SINGLE" : "You can download the QR Code with the filled quantity",
        "MRP_LABEL_PDF": "You can download the MRP Label with the filled quantity",
        "PRODUCT_LABEL_HS_SHIPMENT": "You can download the Product Label with the filled quantity"
    }

    let keysMapping = {
        "ITEM_BARCODE_SINGLE": {
            "itemcode": "Item Code",
            "qty": "Qty",
        },
        "ITEM_QR_CODE_SINGLE": {
            "itemcode": "Item Code",
            "qty": "Qty",
        },
        "MRP_LABEL_PDF": {
            "itemcode": "HSKU",
            "qty": "Qty",
        },
        "PRODUCT_LABEL_HS_SHIPMENT": {
            "itemcode": "Parent SOS Number",
            "qty": "Qty",
        }
    }

    let buttonLabel = {
        "ITEM_BARCODE_SINGLE": "Download",
        "ITEM_QR_CODE_SINGLE": "Download",
        "MRP_LABEL_PDF": "Download",
        "PRODUCT_LABEL_HS_SHIPMENT": "Download"
    }

    useEffect(() => {
        if (downloadDocumentsData?.isSuccess) {
            props.closeModal?.();
        }
    }, [downloadDocumentsData]);

    useEffect(() => {
        if(type === "MRP_LABEL_PDF") {
            dispatchHandler(dispatch, "getTableComponentFifthListRequest", selectedData?.apiPayload, getPermissionKey("purchase", "logistic", "view"))
        }
    }, [])

    const [udfstirngArray, setUdfstirngArray] = useState([])

    useEffect(() => {
        if(getTableComponentFifthListData?.isSuccess) {
            let data = getTableComponentFifthListData?.data?.resource;
            let getArray = data?.map((item) => item?.udfString10);
            setUdfstirngArray(getArray);
        }
    }, [getTableComponentFifthListData?.isSuccess])

    const handleChange = (type, config) => {
        let { value, index } = config || {};
        switch (type) {
            case "updateQty": {
                // console.log("asdfawdsf", formData, index, value);
                let updatedFormData = [...formData];
                updatedFormData[index].qty = value;
                setFormData(updatedFormData);
                break;
            }
        }
    }

    const submitFile = () => {
        setLoading(prev => ({
            ...prev, "submitFile": true,
        }))

        const reader = new FileReader();


        reader.onload = (event) => {
            try {
                const content = event.target.result.trim();
                const lines = content.split("\n");

                let updatedCheckItems = [];
                let updatedFormData = [];
                const rateData = {}
                let index = 0;
                lines.map((line) => {
                    const [code, qty] = line.split(",").map(item => item.trim());

                    if (!code || !qty || isNaN(qty)) {
                        throw new Error("Invalid file format. Each line should be in 'code,qty' format.");
                    }

                    updatedCheckItems.push({
                        itemcode: code
                    })
                    updatedFormData[index] = {
                        qty: qty,
                    }
                    index++;
                });

                setCheckItems(updatedCheckItems);
                setFormData(updatedFormData);
                setLoading(prev => ({
                    ...prev, "submitFile": false,
                }))
                setStep(2);
                // Process parsedData (e.g., send to backend or update state)
            } catch (error) {
                // console.log("File processing error: " + error.message);
                setLoading(prev => ({
                    ...prev, "submitFile": false,
                }))
                customToast({
                    title: "File Read Error!",
                    description: `Failed to read the file.`,
                    status: "error",
                })
            }

        }

        reader.readAsText(currentFile);
    }

    const uploadFile = (e) => {

        let file = e?.target?.files?.[0];
        let fileName = e?.target?.files?.[0]?.name;

        if (uploadFileRef?.current) {
            uploadFileRef.current.value = null;
        }

        let extension = fileName?.substring(fileName?.lastIndexOf("."))?.toLowerCase();
        // console.log("file name", fileName, extension);

        if ([".txt"]?.includes(extension?.toLowerCase())) {
            // Check the validation for the file
            setCurrentFile(file ?? null);
        } else {
            customToast({
                title: "File Validation Error!",
                description: `Invalid file selected! Only .txt are allowed.`,
                status: "error",
            })
        }
    }

    const getSampleTemplateUrl = {
        MRP_LABEL_PDF: "https://staticfiles.supplymint.com/97918ab4-a974-4260-a9c4-872413669c8a/DATA/COMMENTS/MRP_LABEL.txt?response-content-disposition=attachment",
        PRODUCT_LABEL_HS_SHIPMENT: "https://staticfiles.supplymint.com/97918ab4-a974-4260-a9c4-872413669c8a/DATA/COMMENTS/PRODUCT_LABEL.txt?response-content-disposition=attachment"
    };

    if (step == 1) {
        return <div className='uploadBarcodeModal h-full flex flex-col'>
            <GenericFormHeaderComponent
                label={{
                    contentPrimary: "Upload Item Code",
                    contentSecondry: <><LanguageTranslator>Files Supported</LanguageTranslator> : TXT</>
                }}
                closeModal={props.closeModal}
            />
            <div className="px-[15px] h-full flex flex-col">
                <GenericInput
                    className='!block'
                    genInputExtraClass='h-full upload-item-code'
                    gibInnerClassName='!h-full'
                    inputRef={uploadFileRef}
                    placeholder="Upload Barcode"
                    type="upload"
                    inputKey="uploadFile"
                    onChange={uploadFile}
                    value={null}
                    inputProps={() => ({
                        maxSize: 200,
                        acceptFiles: ".txt",
                        renderCustomPlaceholder: () => {
                            return (
                                <div className='gibu-inner mx-auto text-center'>
                                    <div className='inline-block mx-auto mb-3'><Icons.UploadIconBlue /></div>
                                    <LanguageTranslator tag="h4" className='!mb-3 text-sm font-semibold text-[#718096]'>Drag & Drop files here</LanguageTranslator>
                                    {/* <LanguageTranslator tag='div' className='generic-approve-btn flex items-center justify-center !h-[34px] !min-w-[200px] !rounded-[5px]'>Choose File</LanguageTranslator> */}
                                    <GenericCustomButton
                                        type='primary'
                                        label={'Choose File'}
                                        style={{ position: 'static' }}
                                        className='mx-auto'
                                    />
                                    <GenericCustomButton
                                        type='underline'
                                        label="Download Sample"
                                        leftIcon={<Icons.DownloadDocumentsIcon />}
                                        onClick={() => window.open(getSampleTemplateUrl?.[type] ?? "https://staticfiles.supplymint.com/97918ab4-a974-4260-a9c4-872413669c8a/DATA/COMMENTS/Upload%20ItemCode%20Sample.txt?response-content-disposition=attachment", "_blank")}
                                        className={'mx-auto mt-[12px]'}
                                    />
                                </div>
                            )
                        }
                    })}
                />

                {/* If the current file is selected then we need to render the file name */}
                {currentFile && <div className='mt-[12x] px-3 py-2.5 w-fit rounded-[5px] flex gap-5 bg-[#F8F8F8]'>
                    <div className="flex gap-2 items-center">
                        <div className='p-[6px] border border-[#D9D9D9] rounded-[5px]'>
                            <Icons.PdfFileIcon />
                        </div>
                        <div>
                            <p className='text-[13px] font-semibold mb-1'>{currentFile?.name || "-"}</p>
                            <p className='mb-0 text-xs font-medium'>{formatFileSize(currentFile?.size)}</p>
                        </div>
                    </div>
                    <GenericCustomButton
                        leftIcon={<Icons.CrossIcon />}
                        onClick={() => { setCurrentFile(null) }}
                        tooltip="Remove File"
                        type="deafult"
                        className='hover:opacity-75'
                    />
                </div>}
            </div>


            <GenericFormFooterComponent
                buttons={[
                    {
                        type: "default",
                        onClick: props.closeModal,
                        label: 'Close'
                    },
                    {
                        type: "primary",
                        onClick: () => submitFile(),
                        label: 'Submit',
                        loading: loading?.["submitFile"],
                        disabled: () => !currentFile || loading?.["submitFile"]
                    },
                ]}
            />
        </div>
    }

    const downloadDocument = () => {
        let payload = {};
        if(type === "MRP_LABEL_PDF") {
            let obj = {};
            checkItems?.map((val, index) => {
                if(udfstirngArray?.includes(val?.["itemcode"])) {
                    obj = {
                        ...obj,
                        [val?.["itemcode"]]: Number(formData?.[index]?.qty || ""),
                    }
                }
            });
            payload = {
                data: [
                    {
                        "documentId": selectedData?.data?.[0]?.id || "0",
                        "documentNo": selectedData?.data?.[0]?.orderNumber || "",
                        "sku_quantity": obj ?? {}
                    }
                ],
                "filters": {},
                "type": selectedData?.item?.key || "",
                "disposition": "FALSE"
            }
        }
        else if(type=== "PRODUCT_LABEL_HS_SHIPMENT"){
            console.log("rajselectedData", selectedData)
            payload = {
                "data": checkItems?.map((val, index) => {
                    let obj = {
                        "documentId": "0",
                        "documentNo": val?.["itemcode"] || "",
                        "qty": Number(formData?.[index]?.qty || ""),
                    }
                    return obj;
                })?.filter(val => Boolean(val)) || [],

                "filters": {},
                "type": selectedData?.item?.key || "",
                "disposition": "FALSE",
                "erpShipmentNo": selectedData?.data?.[0]?.erpShipmentNo || ""
            }
        }
        else {
            payload = {
                "data": checkItems?.map((val, index) => {
                    let obj = {
                        "documentId": "0",
                        "documentNo": val?.["itemcode"] || "",
                        "qty": Number(formData?.[index]?.qty || ""),
                    }
                    return obj;
                })?.filter(val => Boolean(val)) || [],
    
                "filters": {},
                "type": selectedData?.item?.key || "",
                "disposition": "FALSE"
            }
        }
        // Download the document data
        dispatchHandler(dispatch, "downloadDocumentsRequest", payload, getPermissionKey("common", "commonFunctionality", "downloadpdf"))
    }

    const goBack = () => {
        setStep(1);
        setCurrentFile(null);
        setCheckItems([])
        setFormData({});
    }

    if (step == 2) {
        return (
            <React.Fragment>
                <GenericFormHeaderComponent
                    label={{
                        contentPrimary: headingMapping?.[type],
                        contentSecondry: subHeadingMapping?.[type],
                    }}
                    rowEndComponent={() => {
                        if (props.type == "upload") {
                            if(type == "MRP_LABEL_PDF" || type == "PRODUCT_LABEL_HS_SHIPMENT") return null
                            return (
                                <GenericCustomButton
                                    type="underline"
                                    label="Upload Other Excel"
                                    className="mr-[24px] text-xs"
                                    onClick={() => {
                                        goBack();
                                    }}
                                />
                            )
                        }
                    }}

                    closeModal={props.closeModal}
                />

                {/* Render the List of the selected documents */}
                <div className={`px-[15px] h-[calc(100%-134px)]`}>
                    <div className={`table-v2 table-v2-with-inputs ${props?.type === 'upload' && step === 2 ? 'h-full' : 'min-h-[200px] max-h-[50vh]'}`}>
                        <table>
                            <thead>
                                <tr>
                                    {Object.keys(keysMapping?.[type] || {})?.map(key => (
                                        <th>
                                            {keysMapping?.[type]?.[key] || "-"}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {checkItems?.map((item, index) => (
                                    <tr className="border-b border-borderSlateGrey">
                                        {
                                            Object.keys(keysMapping?.[type] || {})?.map(key => (
                                                <td className={key == "qty" ? "!px-1 !py-1 min-w-[70px]" : ''}>
                                                    <React.Fragment>
                                                        {
                                                            key == "qty" && <GenericInput
                                                                genInputExtraClass='!mb-0'
                                                                type="number"
                                                                inputKey={"itemQty"}
                                                                onChange={(e) => (
                                                                    handleChange("updateQty", {
                                                                        value: e?.target?.value,
                                                                        index: index,
                                                                    })
                                                                )}
                                                                value={formData?.[index]?.qty}
                                                                dependentFieldsObject={["itemQty"]}
                                                            />
                                                        }
                                                        {!["qty"]?.includes(key) && <div className='flex items-center justify-between gap-5'>
                                                            {item?.[key] || "-"}
                                                            {(type === "MRP_LABEL_PDF" && !(udfstirngArray?.includes(item?.[key]))) && <div className='group relative'>
                                                                {<Icons.ErrorIcon />}
                                                                {<span className='generic-tooltip !w-[230px] !-translate-x-1/2 !top-auto !bottom-[calc(100%+7px)] after:!left-1/2 after:!border-[var(--danger-color)_transparent_transparent] !whitespace-normal !bg-danger opacity-0 invisible pointer-events-none group-hover:opacity-100 group-hover:visible group-hover:pointer-events-auto'>HSKU is missing. The item will not be in the selected items.</span>}
                                                            </div>}
                                                        </div>}
                                                        {/* {!["qty"]?.includes(key) && <>{item?.[key] || "-"}</>} */}
                                                    </React.Fragment>
                                                </td>
                                            ))
                                        }
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>


                {/* Render the final submit button here */}
                <GenericFormFooterComponent
                    buttons={[
                        {
                            label:  () => props.type == "upload" && step == 2 ? "Back" : "Close",
                            type: "default",
                            onClick: () => props.type == "upload" && step == 2  ? goBack() : props.closeModal()
                        },
                        {
                            label: buttonLabel?.[type],
                            type: "primary",
                            tooltip: !formData?.some(item => item?.qty > 0) ? "Atleast qty of one item should be greater than 0!" : "",
                            disabled: () => !formData?.some(item => item?.qty > 0) || downloadDocumentsData?.isLoading,
                            onClick: () => props.type == "upload" ? downloadDocument() : props.downloadFunction({
                                item: selectedData?.item,
                                type: selectedData?.type,
                                formData: formData,
                                skipQtyModal: true,
                                qtyEnabled: true,
                            })
                        }
                    ]}
                />
            </React.Fragment>
        )
    }

}

export default DocumentsQtyForPrint